import React from 'react';

const Quote = () => {
  return (
    <div className='quote'>
      <p>
        " <b>Mathematics</b> is not about numbers, equations, computations, or
        algorithms: it is about understanding. " --<b>William Paul Thurston</b>
      </p>
    </div>
  );
}

export default Quote;